import { HttpContextToken } from '@angular/common/http';

export const SKIP_LANGUAGE = new HttpContextToken<boolean>(() => false);